import { createContext, useContext } from 'react';

import { fg } from '@atlaskit/platform-feature-flags';

import {
	API_ORIGIN_LOCAL,
	API_ORIGIN_TEST_SERVER,
	API_PATHNAME_LOCAL,
	API_PATHNAME_STG_PROD,
	REMOTE_MODULE_URI_LOCAL,
	REMOTE_MODULE_URI_PROD,
	REMOTE_MODULE_URI_PROD_FEDM,
	REMOTE_MODULE_URI_STG,
	REMOTE_MODULE_URI_STG_FEDM,
} from './constants';
import type { PostOfficeEnvironmentValues } from './types';

export const buildDefaultEnvironmentValues = (): PostOfficeEnvironmentValues => {
	const isFedRampCompliantUrlsEnabled = fg('post-office-rml-fedramp-compliant-urls');

	return {
		currentEnv: 'local',
		envConfigs: {
			'test-server': {
				remoteModule: {
					origin: REMOTE_MODULE_URI_LOCAL,
					pathname: undefined,
					searchParams: undefined,
				},
				api: {
					origin: API_ORIGIN_TEST_SERVER,
					pathname: API_ORIGIN_TEST_SERVER,
					searchParams: undefined,
				},
			},
			test: {
				remoteModule: {
					origin: REMOTE_MODULE_URI_LOCAL,
					pathname: undefined,
					searchParams: undefined,
				},
				api: {
					origin: API_ORIGIN_LOCAL,
					pathname: API_PATHNAME_LOCAL,
					searchParams: undefined,
				},
			},
			local: {
				remoteModule: {
					origin: REMOTE_MODULE_URI_LOCAL,
					pathname: undefined,
					searchParams: undefined,
				},
				api: {
					origin: API_ORIGIN_LOCAL,
					pathname: API_PATHNAME_LOCAL,
					searchParams: undefined,
				},
			},
			dev: {
				remoteModule: {
					origin: REMOTE_MODULE_URI_LOCAL,
					pathname: undefined,
					searchParams: undefined,
				},
				api: {
					origin: API_ORIGIN_LOCAL,
					pathname: API_PATHNAME_LOCAL,
					searchParams: undefined,
				},
			},
			staging: {
				remoteModule: {
					origin: REMOTE_MODULE_URI_STG,
					pathname: undefined,
					searchParams: undefined,
				},
				api: {
					origin: undefined,
					pathname: API_PATHNAME_STG_PROD,
					searchParams: undefined,
				},
			},
			'stg-fedm-east': {
				remoteModule: {
					origin: isFedRampCompliantUrlsEnabled
						? REMOTE_MODULE_URI_STG_FEDM
						: REMOTE_MODULE_URI_STG,
					pathname: undefined,
					searchParams: undefined,
				},
				api: {
					origin: undefined,
					pathname: API_PATHNAME_STG_PROD,
					searchParams: undefined,
				},
			},
			production: {
				remoteModule: {
					origin: REMOTE_MODULE_URI_PROD,
					pathname: undefined,
					searchParams: undefined,
				},
				api: {
					origin: undefined,
					pathname: API_PATHNAME_STG_PROD,
					searchParams: undefined,
				},
			},
			'prod-fedm-east': {
				remoteModule: {
					origin: isFedRampCompliantUrlsEnabled
						? REMOTE_MODULE_URI_PROD_FEDM
						: REMOTE_MODULE_URI_PROD,
					pathname: undefined,
					searchParams: undefined,
				},
				api: {
					origin: undefined,
					pathname: API_PATHNAME_STG_PROD,
					searchParams: undefined,
				},
			},
		},
	};
};

export const defaultEnvironmentValues: PostOfficeEnvironmentValues =
	buildDefaultEnvironmentValues();

export const PostOfficeEnvironment =
	createContext<PostOfficeEnvironmentValues>(defaultEnvironmentValues);

export const PostOfficeEnvironmentProvider = PostOfficeEnvironment.Provider;

export const usePostOfficeEnvironment = () => useContext(PostOfficeEnvironment);
